module.exports = __webpack_public_path__ + "img/Fortebon_2.9116f40d.jpg";